export default {
      id: "kefulist-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "static/img/icons.38294312.svg#kefulist",
      toString: function () {
        return this.url;
      }
    }